import { useEffect, useState } from "react";
import api from "@/lib/api";

const naira = (n) => "₦" + Number(n || 0).toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const month = (p) => (p ? new Date(`${p}-01T00:00:00`).toLocaleDateString("en-GB", { month: "short", year: "numeric" }) : "—");
const TONE = { paid: "bg-emerald-50 text-emerald-700", due: "bg-klein/10 text-klein", overdue: "bg-amber-50 text-amber-700", upcoming: "bg-ink/5 text-ink/60" };
const LABEL = { paid: "Paid", due: "This month", overdue: "Not yet deducted", upcoming: "Upcoming" };

// Month-by-month repayment plan for one loan/advance.
export default function LoanSchedule({ loanId }) {
    const [d, setD] = useState(null);
    useEffect(() => { api.get(`/loans/${loanId}/schedule`).then(({ data }) => setD(data)).catch(() => setD({ rows: [] })); }, [loanId]);
    if (!d) return <div className="py-4 text-sm text-ink/40">Loading schedule…</div>;
    if (!d.rows.length) return <div className="py-4 text-sm text-ink/40">No repayment schedule yet.</div>;
    const pct = d.rows.length ? Math.round((d.paid_count / d.rows.length) * 100) : 0;
    return (
        <div className="py-3" data-testid={`loan-schedule-${loanId}`}>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-1 text-xs text-ink/60 mb-3">
                <span><b className="text-ink">{d.paid_count}</b> of {d.rows.length} paid</span>
                <span>Repaid <b className="text-emerald-700">{naira(d.paid_total)}</b></span>
                <span>Remaining <b className="text-ink">{naira(d.remaining)}</b></span>
                {d.planned && <span className="text-amber-700">Planned — starts once disbursed</span>}
                <div className="h-1.5 w-40 bg-ink/10 rounded-full overflow-hidden"><div className="h-full bg-emerald-500" style={{ width: `${pct}%` }} /></div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
                {d.rows.map((r) => (
                    <div key={r.n} className="border border-ink/10 bg-white px-3 py-2" data-testid={`loan-schedule-row-${loanId}-${r.n}`}>
                        <div className="flex items-center justify-between gap-2"><span className="text-xs font-semibold text-ink">{month(r.period)}</span><span className="text-[10px] text-ink/40">#{r.n}</span></div>
                        <div className="mt-0.5 text-sm tabular-nums text-ink">{naira(r.amount)}</div>
                        <span className={`mt-1 inline-block rounded-full px-2 py-0.5 text-[10px] font-semibold ${TONE[r.status]}`}>{LABEL[r.status]}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
